// @flow

import { Order } from '../entities/order';
import I18n from '../i18n/I18n';

import ApiConstants from '../constants/ApiConstants';

import { Logger } from '../utils';

import SvgIcon from '../components/SvgIcon';

export default class OrderViewUtils {
  static getLabelForPlatform(platform: String) {
    switch (platform) {
      case ApiConstants.Platform.IOS:
        return I18n.tr('order.source.platform.IOS');
      case ApiConstants.Platform.ANDROID:
        return I18n.tr('order.source.platform.ANDROID');
      case ApiConstants.Platform.BACK_OFFICE_WEB:
        return I18n.tr('order.source.platform.BACK_OFFICE_WEB');
      case ApiConstants.Platform.PLUGIN_WEB:
        return I18n.tr('order.source.platform.PLUGIN_WEB');
      case ApiConstants.Platform.BOT:
        return I18n.tr('order.source.platform.BOT');
      case ApiConstants.Platform.POS:
        return I18n.tr('order.source.platform.POS');
      case ApiConstants.Platform.KIOSK:
        return I18n.tr('order.source.platform.KIOSK');
      case ApiConstants.Platform.OTHER:
        return I18n.tr('order.source.platform.OTHER');
      default:
        return null;
    }
  }

  static getLabelForMode(mode: OrderMode) {
    switch (mode) {
      case Order.OrderMode.ON_SITE:
        return I18n.tr('order.on_site');
      case Order.OrderMode.TAKE_AWAY:
        return I18n.tr('order.take_away');
      case Order.OrderMode.DELIVERY:
        return I18n.tr('order.delivery');
      default:
        Logger.warning('OrderViewUtils', `getLabelForMode: invalid mode ${mode}`)
        return '';
    }
  }

  static getIconForMode(mode: OrderMode) {
    switch (mode) {
      case Order.OrderMode.ON_SITE:
        return SvgIcon.ORDER_ON_SITE;
      case Order.OrderMode.TAKE_AWAY:
        return SvgIcon.ORDER_TAKE_AWAY;
      case Order.OrderMode.DELIVERY:
        return SvgIcon.ORDER_DELIVERY;
      default:
        Logger.warning('OrderViewUtils', `getIconForMode: invalid mode ${mode}`)
        return '';
    }
  }

  static getStatusLabel(status: string): string {
    switch (status) {
      case Order.OrderStatus.CREATED:
        return 'CREATED';
      case Order.OrderStatus.SENT:
        return 'En attente';
      case Order.OrderStatus.RECEIVED:
        return 'Acceptée';
      // case Order.OrderStatus.PRODUCING:
        // return 'En production';
      case Order.OrderStatus.READY:
        return 'Prête';
      case Order.OrderStatus.IN_DELIVERY:
        return 'En livraison';
      case Order.OrderStatus.DELIVERED:
        return 'Récupérée';
      case Order.OrderStatus.CANCELED:
        return 'Annulée';
      case Order.OrderStatus.FAILED:
        return 'Erreur';
      default:
        Logger.warning('OrderViewUtils', `getStatusLabel: invalid status ${status}`)
        return '';
    }
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/OrderViewUtils.js